// extracted by mini-css-extract-plugin
export const header__illustration = "about-module--header__illustration--fNhGQ";
export const portrait__container = "about-module--portrait__container--1pjaK";
export const social__button = "about-module--social__button--1ce7W";